import { formatLeverage } from "../../../helper/formatLeverage";

export default function LeverageValueList({ values = [], onMove, onRemove }) {
  if (!values.length) {
    return <p className="text-sm text-zi-text-light/50 dark:text-zi-text-dark/50">هنوز مقداری اضافه نشده است.</p>;
  }

  return (
    <ul className="flex flex-wrap gap-2" aria-label="اهرم‌های مجاز">
      {values.map((value, index) => (
        <li key={value} className="flex items-center gap-1 rounded-lg border border-zi-border-light dark:border-zi-border-dark px-2 py-1 text-zi-text-light dark:text-zi-text-dark">
          <span className="font-medium [direction:ltr]">{formatLeverage(value)}</span>
          {onMove && <button type="button" aria-label={`انتقال ${value} به قبل`} disabled={index === 0} onClick={() => onMove(index, -1)} className="px-1 disabled:opacity-30">→</button>}
          {onMove && <button type="button" aria-label={`انتقال ${value} به بعد`} disabled={index === values.length - 1} onClick={() => onMove(index, 1)} className="px-1 disabled:opacity-30">←</button>}
          {onRemove && <button type="button" aria-label={`حذف ${value}`} onClick={() => onRemove(index)} className="px-1 text-red-500">×</button>}
        </li>
      ))}
    </ul>
  );
}
